import TruckModelModal from './TruckModelModal';

export { default as useTruckModelModal } from './useTruckModelModal';
export default TruckModelModal;
